const MAX_DIMENSION = 1600;
const JPEG_QUALITY = 0.8;

/**
 * Downscale an image file and encode it as a JPEG data URL, to keep the
 * editor state small enough to be sent to the backend.
 * @param {File} file - Image file picked by the user.
 * @returns {Promise<string>} JPEG data URL.
 */
export const compressImage = (file) =>
    new Promise((resolve, reject) => {
        const objectUrl = URL.createObjectURL(file);
        const image = new Image();

        image.onload = () => {
            if (!image.width || !image.height) {
                URL.revokeObjectURL(objectUrl);
                reject(new Error("Image has no dimensions"));
                return;
            }
            const scale = Math.min(
                1,
                MAX_DIMENSION / Math.max(image.width, image.height)
            );
            const canvas = document.createElement("canvas");
            canvas.width = Math.round(image.width * scale);
            canvas.height = Math.round(image.height * scale);

            const context = canvas.getContext("2d");
            // JPEG has no alpha channel, transparent pixels would turn black
            context.fillStyle = "#fff";
            context.fillRect(0, 0, canvas.width, canvas.height);
            context.drawImage(image, 0, 0, canvas.width, canvas.height);

            URL.revokeObjectURL(objectUrl);
            resolve(canvas.toDataURL("image/jpeg", JPEG_QUALITY));
        };
        image.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            reject(new Error("Unable to read image"));
        };

        image.src = objectUrl;
    });
